export default __webpack_public_path__ + "assets/img/whiteboard-bg.b58588a8188817860833102fb5c36b41.svg";